import React from "react";
import { confirmedPurchases, purchasePreview } from "./data/megapack";
import { Hero } from "./components/sections/Hero";
import { ProblemSection } from "./components/sections/ProblemSection";
import { TomosSection } from "./components/sections/TomosSection";
import { BonusSection } from "./components/sections/BonusSection";
import { PricingSection } from "./components/sections/PricingSection";
import { ComparisonSection } from "./components/sections/ComparisonSection";
import { MoreTestimonials } from "./components/sections/MoreTestimonials";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { FaqSection } from "./components/sections/FaqSection";
import { CostSection } from "./components/sections/CostSection";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
import { PurchaseNotification } from "./components/PurchaseNotification";
type AppProps = {
  /** Muestra la notificación flotante en modo vista previa mientras no haya compras reales */
  previewPurchaseNotification?: boolean;
};
export function App({
  previewPurchaseNotification = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-night font-sans text-white" data-id="element-0" data-mp="3rcj7q5oi4587">
      <Hero data-id="element-1" data-mp="3recbnd7qcbci" />
      <main data-id="element-2" data-mp="5yj0slx59ec">
        <ProblemSection data-id="element-3" data-mp="5opiv1o0k3w" />
        <TomosSection data-id="element-4" data-mp="4wx1t3d72hu" />
        <BonusSection data-id="element-5" data-mp="56nfhsbnbo2" />
        <PricingSection data-id="element-6" data-mp="7st1bvnjh3n" />
        <ComparisonSection data-id="element-7" data-mp="2zlle8zeb8glo" />
        <MoreTestimonials data-id="element-8" data-mp="2zmeowbge3q93" />
        <GuaranteeSection data-id="element-9" data-mp="2zn6actg9w7ln" />
        <FaqSection data-id="element-10" data-mp="33mf2xuzktzfm" />
        <CostSection data-id="element-11" data-mp="33lwywc6oagx5" />
        <FinalCTA data-id="element-12" data-mp="33ngfy505kvzz" />
      </main>
      <Footer data-id="element-13" data-mp="33oi337ug18y2" />
      <PurchaseNotification purchases={confirmedPurchases} previewItem={previewPurchaseNotification ? purchasePreview : null} data-id="element-14" data-mp="38lrpsfqg76i7" />
    </div>;
}